<template>
  <div>
    <v-menu
      v-for="(menu, index) in menus" :key="index"
      v-model="menu.show"
      :ref="'menu' + index"
      :activator="menu.activator"
      :close-on-content-click="false"
      :transition="transition"
      :origin="animationOrigin"
      :right="autoXPosition && showRight"
      :left="autoXPosition && !showRight"
      @input="onClose"
      @update:returnValue="onClose"
      v-bind="$attrs">

      <v-card v-if="menu.data" class="card-menu">

        <v-btn icon :dark="darkBtn" @click="closeMenu(index)">
          <v-icon>clear</v-icon>
        </v-btn>

        <slot name="data" :data="menu.data" :index="index"/>

      </v-card>

    </v-menu>
  </div>
</template>

<script>
export default {
    name: 'ToggleableMenu',
    props: {
        transition: {
            type: String,
            default: 'scale-transition'
        },
        origin: {
            type: String,
            default: 'center center'
        },
        darkBtn: Boolean,
        autoXPosition: Boolean
    },
    data: () => ({
        showRight: true,
        menus: [
            {
                data: null,
                activator: null,
                show: false
            },
            {
                data: null,
                activator: null,
                show: false
            }
        ]
    }),
    computed: {
        activeMenuIndex () {
            return this.menus[0].show ? 0 : 1
        },
        animationOrigin () {
            if (!this.autoXPosition) {
                return this.origin
            } else {
                let parts = this.origin.split(' ')
                return parts[0] + ' ' + (this.showRight ? 'left' : 'right')
            }
        }
    },
    methods: {
        openMenu (index, data, activatorId) {
            let menu = this.menus[index]
            menu.data = data
            menu.activator = document.querySelector('#' + activatorId)
            menu.show = true
            this.showRight = this.isRightPositioned()
        },
        isRightPositioned () {
            let menuRef = this.$refs['menu' + this.activeMenuIndex]
            if (menuRef) {
                let bounds = this.menus[this.activeMenuIndex].activator.getBoundingClientRect()
                return bounds.left <= 800
            }
            return true
        },
        closeMenu (index) {
            let menu = this.menus[index]
            menu.show = false
            menu.activator = null
        },
        show (activatorId, data) {
            let openedIndex = this.activeMenuIndex
            this.closeMenu(openedIndex) //  Chiudo il menu già aperto
            this.openMenu(1 - openedIndex, data, activatorId) //  Apro l'altro menu
        },
        close () {
            this.closeMenu(0)
            this.closeMenu(1)
        },
        onClose (val) {
            if (!this.menus[0].show) this.menus[0].activator = null
            if (!this.menus[1].show) this.menus[1].activator = null
            if (!this.menus[0].show && !this.menus[1].show) {
                //  Entrambi i menu sono stati chiusi
                this.$emit('close:all')
            }
        }
    }
}
</script>
<style scoped lang="scss">
  .card-menu {
    .v-btn {
      z-index: 9;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
</style>
